import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listAgencyAudits } from "@/lib/agency.functions";

const GOLD = "#C8A84B";

export const Route = createFileRoute("/agency/audits")({
  component: AgencyAuditsPage,
});

function AgencyAuditsPage() {
  const fetchAudits = useServerFn(listAgencyAudits);
  const { data, isLoading } = useQuery({
    queryKey: ["agency-audits"],
    queryFn: () => fetchAudits(),
    staleTime: 15_000,
  });
  const audits = data?.audits ?? [];
  return (
    <div className="grid gap-6">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p
            className="text-[10px] font-medium uppercase tracking-[0.22em]"
            style={{ color: GOLD }}
          >
            Audits
          </p>
          <h1 className="mt-2 font-display text-3xl font-semibold text-foreground">
            All redeemed audits
          </h1>
        </div>
        <Link
          to="/agency/new-audit"
          className="rounded-full bg-foreground px-5 py-2.5 text-sm font-medium text-background hover:opacity-90"
        >
          New audit →
        </Link>
      </header>

      {isLoading && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      {!isLoading && audits.length === 0 && (
        <p className="rounded-2xl border border-border bg-card/20 p-8 text-center text-sm text-muted-foreground">
          You haven't launched any audits yet.
        </p>
      )}
      <div className="grid gap-3">
        {audits.map((a) => (
          <div
            key={a.id}
            className="grid gap-3 rounded-2xl border border-border bg-card/30 p-4 sm:grid-cols-[1fr_auto] sm:items-center"
          >
            <div className="min-w-0">
              <p className="truncate font-medium text-foreground">
                {a.client_name ?? a.website_url}
              </p>
              <p className="mt-0.5 truncate text-xs text-muted-foreground">
                {a.order_number} · {a.website_url} ·{" "}
                {new Date(a.created_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex items-center gap-3">
              {typeof a.audit_score === "number" && (
                <span className="rounded-full border border-border bg-background/40 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground">
                  Score {a.audit_score}
                </span>
              )}
              <span className="rounded-full border border-border bg-background/40 px-3 py-1 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                {a.status.replace(/_/g, " ")}
              </span>
              {a.report_url && (
                <a
                  href={a.report_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xs font-medium text-foreground underline"
                >
                  Report
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}